import { defineChain } from 'viem'

export const homeVerse = defineChain({
  id: 19011,
  name: 'HOME Verse',
  nativeCurrency: { name: 'Oasys', symbol: 'OAS', decimals: 18 },
  rpcUrls: {
    default: {
      http: ['https://rpc.mainnet.oasys.homeverse.games'],
    },
  },
  blockExplorers: {
    default: {
      name: 'HOME Verse Mainnet Explorer',
      url: 'https://explorer.oasys.homeverse.games',
      apiUrl: 'https://explorer.oasys.homeverse.games/api',
    },
  },
  testnet: false,
})
